import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccordionCollapsedState {
	[key: string]: boolean;
}

interface AttributeSearchState {
	[key: string]: string
}

interface LastScrollTopState {
	id: string,
	scrollTop: number
}

interface LastAttributeViewportTopState {
	name: string;
	y: number;
}

interface UIState {
	accordionCollapsed: AccordionCollapsedState;
	attributeSearch: AttributeSearchState;
	lastScrollTop: LastScrollTopState;
	isDrawerOpen: boolean;
	drawerScrollTop: number;
	lastAttributeViewportTop: LastAttributeViewportTopState;
}

const initialState: UIState = {
	accordionCollapsed: {},
	attributeSearch: {},
	lastScrollTop: {
		id: null,
		scrollTop: 0
	},
	isDrawerOpen: false,
	drawerScrollTop: 0,
	lastAttributeViewportTop: undefined
};

const leftNavSlice = createSlice({
	name: 'leftNav',
	initialState,
	reducers: {
		setDynamicAccordionState: (state, action: PayloadAction<{ id: string, isCollapsed: boolean }>) => {

			const { id, isCollapsed } = action.payload;
			state.accordionCollapsed[id] = isCollapsed;

		},
		setDynamicSearchValue: (state, action: PayloadAction<{ id: string, value: string }>) => {

			const { id, value } = action.payload;
			state.attributeSearch[id] = value;

		},
		setDynamicLastCollapsibleScrollTop: (state, action: PayloadAction<{ id: string, scrollTop: number }>) => {

			state.lastScrollTop = { ...action.payload };

		},
		setDynamicDrawerOpenState: (state, action: PayloadAction<boolean>) => {

			state.isDrawerOpen = action.payload;

		},
		setDynamicDrawerScrollTop: (state, action: PayloadAction<number>) => {

			state.drawerScrollTop = action.payload;
			state.lastAttributeViewportTop = undefined;

		},
		setDynamicLastAttributeViewportTop: (state, action: PayloadAction<{ name: string, y: number }>) => {

			state.lastAttributeViewportTop = { ...action.payload };
			state.drawerScrollTop = undefined;

		}
	}
});

export const {
	setDynamicAccordionState,
	setDynamicSearchValue,
	setDynamicLastCollapsibleScrollTop,
	setDynamicDrawerOpenState,
	setDynamicDrawerScrollTop,
	setDynamicLastAttributeViewportTop
} = leftNavSlice.actions;

export const dynamicPersistenceStore = configureStore({
	reducer: {
		ui: leftNavSlice.reducer
	}
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof dynamicPersistenceStore.getState>;
export type AppDispatch = typeof dynamicPersistenceStore.dispatch;
